module.exports = __webpack_public_path__ + "img/Personal-icon.f92c0cfb.png";